// ONE-PER-CUSTOMER LIMIT

document.addEventListener('DOMContentLoaded', function () {

  // Change this handle for testing; later set back to 'air-toobz'
  var LIMIT_HANDLE = 'air-toobz';

  // --- PRODUCT PAGE LIMIT (forces qty = 1 on that product) ---
  if (window.location.pathname.includes('/products/' + LIMIT_HANDLE)) {

    var qtyInputs = document.querySelectorAll('form[action^="/cart/add"] input[name="quantity"]');
    qtyInputs.forEach(function (input) {
      input.value = 1;
      input.setAttribute('min', '1');
      input.setAttribute('max', '1');
    });

    var forms = document.querySelectorAll('form[action^="/cart/add"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="quantity"]');
        if (input) input.value = 1;
      });
    });
  }

  // --- CART LIMIT (keeps checking and correcting qty back to 1) ---
  function enforceCartLimit() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var limitedItem = cart.items.find(function (i) {
          return i.handle === LIMIT_HANDLE && i.quantity > 1;
        });

        if (!limitedItem) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: limitedItem.key,    // line item key
            quantity: 1
          })
        }).then(function () {
          // Reload so cart / drawer shows corrected quantity
          location.reload();
        });
      })
      .catch(function () {
        // fail silently
      });
  }

  // Run once on load
  enforceCartLimit();
  // And keep checking (for AJAX quantity changes)
  setInterval(enforceCartLimit, 2000);

});
